<template>
    <div>
        <h3>武汉市新冠肺炎疫情防控指挥部发放捐赠物资统计</h3>
        <div class="source">
            <div>
                数据来源 武汉红十字会
            </div>
            <a href="http://www.wuhanrc.org.cn/dtzx/jzgst.htm">武汉红十字会官网</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'header'
    }
</script>

<style scoped>
    .source {
        text-align: right;
    }

    h3 {
        font-size: 24px;
        text-align: center;
    }
</style>
